import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/about-breadcrumb.webp'

const TermsConditions=()=>{
useEffect(() => {
            document.title =
              "Terms & Conditions | Gurukrupa Wood Pvt. Ltd.";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Read the terms and conditions for ordering custom wooden pallets, crates, and packaging solutions from Gurukrupa Wood Pvt. Ltd."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://gurukrupawood.com/terms-conditions");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Terms & Conditions | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Read the terms and conditions for ordering custom wooden pallets, crates, and packaging solutions from Gurukrupa Wood Pvt. Ltd."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://gurukrupawood.com/terms-conditions");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://gurukrupawood.com/privacy-policy.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Terms & Conditions | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Read the terms and conditions for ordering custom wooden pallets, crates, and packaging solutions from Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://gurukrupawood.com/privacy-policy.webp"
            );
          }
          }, []);

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};
    return(
        <>
          <Breadcrumb
  pageName="Terms & Conditions"
  bgImage={bgImg}
/>

 <motion.section className="privacy-policy-section container"
        variants={container}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}>

             <motion.h2 className="section-heading" variants={fadeUp}>1. Definitions</motion.h2>
<motion.p className="section-text" variants={fadeUp}>In this Contract the following listed words shall have the following meanings:</motion.p>
<ul>
  <motion.li variants={fadeUp}><strong>Customer:</strong> Any individual, business, commercial entity, enterprise, or legal representative that engages Gurukrupa Wood Pvt. Ltd. for custom wooden packaging, wooden pallets, plywood boxes, wooden crates, timber products, or related services.</motion.li>
  <motion.li variants={fadeUp}><strong>Services:</strong> All timber processing, custom packaging design, manufacturing, ISPM 15 heat treatment, pallet fabrication, packing, delivery, and related industrial packaging services provided by Gurukrupa Wood Pvt. Ltd.</motion.li>
  <motion.li variants={fadeUp}><strong>We, Our, Us:</strong> Shall mean Gurukrupa Wood Pvt. Ltd.</motion.li>
  <motion.li variants={fadeUp}><strong>Website:</strong> The official website <a href="https://gurukrupawood.com">gurukrupawood.com</a>.</motion.li>
  <motion.li variants={fadeUp}><strong>Company:</strong> Gurukrupa Wood Pvt. Ltd., the manufacturer and supplier of industrial wooden packaging products and timber solutions.</motion.li>
  <motion.li variants={fadeUp}><strong>Terms of Use:</strong> These Terms & Conditions including any future amendments.</motion.li>
  <motion.li variants={fadeUp}><strong>Party:</strong> The Customer and Gurukrupa Wood Pvt. Ltd. collectively referred to as the “Parties”.</motion.li>
  <motion.li variants={fadeUp}><strong>You:</strong> Any natural or legal person browsing, accessing, or using the Website or purchasing products/services from Us.</motion.li>
  <motion.li variants={fadeUp}><strong>Contract:</strong> Any purchase order, agreement, quotation acceptance, invoice, or transaction entered into between the Customer and Gurukrupa Wood Pvt. Ltd.</motion.li>
</ul>
<motion.p className="section-text" variants={fadeUp}>In this Contract, clause headings are included for convenience only and shall not affect interpretation.</motion.p>

<motion.h2 className="section-heading" variants={fadeUp}>2. Interpretation</motion.h2>
<motion.p className="section-text" variants={fadeUp}>These Terms & Conditions apply to all products, custom packaging solutions, and services provided by Gurukrupa Wood Pvt. Ltd. unless otherwise agreed in writing. If any conflict arises between additional written agreements and these Terms, the additional written agreement shall prevail.</motion.p>

<motion.h2 className="section-heading" variants={fadeUp}>3. Service Requests & Instructions</motion.h2>
<ul>
 <motion.li variants={fadeUp}>Requests for custom packaging, products, or timber services may be submitted via phone, email, online inquiry forms, or direct consultation.</motion.li>
<motion.li variants={fadeUp}>Gurukrupa Wood Pvt. Ltd. may request technical specifications, dimensions, cargo weight details, company registration information, and other relevant documentation required to complete the quotation and order fulfillment process.</motion.li>
<motion.li variants={fadeUp}>Clients are responsible for ensuring all provided measurements, specifications, and shipment details are accurate, complete, and up to date.</motion.li>
</ul>

<motion.h2 className="section-heading" variants={fadeUp}>4. Service Availability</motion.h2>
<ul>
<motion.li variants={fadeUp}>All manufacturing, timber supply, and packaging services are subject to material availability, quality inspections, and international phytosanitary compliance standards (including ISPM 15 heat treatment).</motion.li>
<motion.li variants={fadeUp}>Gurukrupa Wood Pvt. Ltd. reserves the right to refuse, modify, or delay orders where accurate cargo specifications are unavailable, material standards cannot be met, or compliance issues exist.</motion.li>
</ul>

<motion.h2 className="section-heading" variants={fadeUp}>5. Fees & Payments</motion.h2>
<ul>
  <motion.li variants={fadeUp}>Quotes provided are valid estimates based on initial dimensions, material specifications, cargo weights, and order volumes available at the time of inquiry.</motion.li>
  <motion.li variants={fadeUp}>Additional charges may apply for customized designs, specialized ISPM 15 heat treatment certifications, transportation, handling, or design modifications requested after order confirmation.</motion.li>
  <motion.li variants={fadeUp}>Payment terms, including required advance deposits or credit terms, will be specified in the formal quotation or invoice and must be settled within the agreed timeframe prior to dispatch or delivery.</motion.li>
</ul>

<motion.h2 className="section-heading" variants={fadeUp}>6. Liability</motion.h2>
<ul>
  <motion.li variants={fadeUp}>Gurukrupa Wood Pvt. Ltd. shall not be liable for delivery or manufacturing delays caused by raw material shortages, customs or port clearances, shipping carrier delays, severe weather, or circumstances beyond our reasonable control.</motion.li>
  <motion.li variants={fadeUp}>We are not responsible for product damage, structural failure, or transit issues resulting from inaccurate load weight, improper dimensions, or incorrect packaging specifications supplied by the client.</motion.li>
  <motion.li variants={fadeUp}>Our maximum liability for any claim shall be limited strictly to the replacement or repair of defective products, or a refund up to the invoice value of the affected goods, to the extent permitted under applicable law.</motion.li>
</ul>

<motion.h2 className="section-heading" variants={fadeUp}>7. Website Usage</motion.h2>
<ul>
  <motion.li variants={fadeUp}>Content on this website is provided for general informational purposes only.</motion.li>
  <motion.li variants={fadeUp}>Users may not copy, reproduce, or distribute any website content without prior written permission.</motion.li>
  <motion.li variants={fadeUp}>External links provided on this website are for convenience only and Apex Garage Doors is not responsible for third-party content.</motion.li>
</ul>

<motion.h2 className="section-heading" variants={fadeUp}>8. Privacy</motion.h2>
<motion.p className="section-text" variants={fadeUp}>Your personal and business information is handled in accordance with our Privacy Policy and applicable data protection laws.</motion.p>

<motion.h2 className="section-heading" variants={fadeUp}>9. Amendments</motion.h2>
<motion.p className="section-text" variants={fadeUp}>Gurukrupa Wood Pvt. Ltd. reserves the right to update or modify these Terms & Conditions at any time without prior notice.</motion.p>

<motion.h2 className="section-heading" variants={fadeUp}>10. Contact Information</motion.h2>
<motion.p className="section-text" variants={fadeUp}>For any questions regarding these Terms & Conditions, please contact us at <a href="mailto:jignesh@gurukrupawood.com">jignesh@gurukrupawood.com</a>.</motion.p>

<motion.p className="section-text" variants={fadeUp}>© {new Date().getFullYear()} – Gurukrupa Wood Pvt. Ltd. All Rights Reserved.</motion.p>
    </motion.section>
        </>
    )
}
export default TermsConditions;